// extracted by mini-css-extract-plugin
export var actions = "_4k-0";
export var actionsContainer = "_4k-7";
export var border = "_4k-1";
export var childFullHeight = "_4k-e";
export var collapse = "_4k-2";
export var content = "_4k-9";
export var contentChild = "_4k-d";
export var fullscreen = "_4k-b";
export var hasLeftRadius = "_4k-q";
export var headerContainer = "_4k-3";
export var headerRow = "_4k-5";
export var hidePadding = "_4k-a";
export var navCollapsedGap = "_4k-r";
export var noScrollX = "_4k-s";
export var noScrollY = "_4k-t";
export var noTopPadding = "_4k-o";
export var optOutTopPadding = "_4k-c";
export var outletContent = "_4k-k";
export var outletContentInner = "_4k-l";
export var outletLeadingPanel = "_4k-h";
export var outletLeadingPanelAttention = "_4k-i";
export var outletResizeDivider = "_4k-j";
export var outletSplit = "_4k-f";
export var outletSplitResizing = "_4k-g";
export var pageMain = "_4k-p";
export var pageOuter = "_4k-m";
export var pagePadding = "_4k-8";
export var profile = "_4k-u";
export var profileContainer = "_4k-v";
export var profileImage = "_4k-w";
export var profileMain = "_4k-x";
export var profileSubtitle = "_4k-z";
export var profileTitle = "_4k-y";
export var showLeftPadding = "_4k-n";
export var tabsPortalSlot = "_4k-6";
export var tabsWrapper = "_4k-4";
export var title = "_4k-10";